import { Cart } from "models/Product";
import CartHeader from "./CartHeader";
import ProductItem from "./ProductItem";
import ProductItemMobileView from "./ProductItemMobileView";

const ShoppingCart = ({ cart }: { cart: Cart }) => {
  return <>
    <div className="d-none d-sm-none d-md-block">
      <CartHeader></CartHeader>
      {cart?.items?.map(p => <ProductItem product={p}></ProductItem>)}
    </div>
    <div className="d-block d-sm-block d-md-none">
      {cart?.items?.map(p => <ProductItemMobileView product={p}></ProductItemMobileView>)}
    </div>
  </>;
};

export default ShoppingCart;